import Carousel from "./Carousel";
import { carouselOptions } from "../../config";

export const carousel = {
  init: (store) => {
    const carousels = document.querySelectorAll(".sd-carousel");
    [...carousels].forEach(
      (carousel) =>
        new Carousel(carousel, store, carouselOptions[`#${carousel.id}`] || {})
    );
  },
};

export default carousel;
